import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { useAppSelector } from 'store';
import { useState } from 'react';
import {
  GENERAL__COLLARTYPE,
  GENERAL__WORKERCLASS,
  PARITAIR_COMITE__END_DATE,
  PARITAIR_COMITE__EXPERIENCE_OR_AGE,
  PARITAIR_COMITE__START_DATE,
  WAGE_INDEXATION__ORIGINAL_VALUES,
} from 'translations/constants';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { UPDataGrid } from 'components/data-grid';
import { wageIndexationSelector } from 'store/selectors/wage-indexation-selectors';
import { getDataGridColumns } from './helpers';
import { WageIndexationHalfGridContainer } from './styles';

const OriginalWageValuesGrid: React.FC = () => {
  const [t] = useTranslation();
  const [rowOnHover, setRowOnHover] = useState<number>();

  const wageData = useAppSelector(wageIndexationSelector);

  const workerclassColumns: GridColDef[] = [
    { field: 'id', headerName: '', hide: true },
    {
      field: 'yearsOfExperience',
      headerName: t(PARITAIR_COMITE__EXPERIENCE_OR_AGE),
      width: 160,
      editable: false,
      sortable: false,
      align: 'center',
      headerAlign: 'center',
      sortingOrder: ['asc'],
    },
    {
      field: 'collarType',
      headerName: t(GENERAL__COLLARTYPE),
      width: 150,
      editable: false,
      sortable: false,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'workerclass',
      headerName: t(GENERAL__WORKERCLASS),
      width: 150,
      editable: false,
      sortable: false,
      align: 'center',
      headerAlign: 'center',
    },
    ...getDataGridColumns(),
    {
      field: 'startDate',
      headerName: t(PARITAIR_COMITE__START_DATE),
      width: 150,
      editable: false,
      sortable: false,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: GridRenderCellParams<Date>) => {
        if (params.value !== null) {
          const dateValue = new Date(params.value);
          return (
            <Box sx={{ display: 'flex', flexDirection: 'row' }}>
              {dateValue.getDate()}-{dateValue.getMonth() + 1}-{dateValue.getFullYear()}
            </Box>
          );
        }
        return <Box />;
      },
      type: 'date',
    },
    {
      field: 'endDate',
      headerName: t(PARITAIR_COMITE__END_DATE),
      width: 150,
      editable: false,
      sortable: false,
      type: 'date',
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: GridRenderCellParams<Date>) => {
        if (params.value !== null) {
          const dateValue = new Date(params.value);
          return (
            <Box sx={{ display: 'flex', flexDirection: 'row' }}>
              {dateValue.getDate()}-{dateValue.getMonth() + 1}-{dateValue.getFullYear()}
            </Box>
          );
        }
        return <Box />;
      },
    },
  ];

  return (
    <WageIndexationHalfGridContainer>
      <Typography>{t(WAGE_INDEXATION__ORIGINAL_VALUES)}</Typography>
      <UPDataGrid
        rows={wageData ?? []}
        columns={workerclassColumns}
        setRowOnHover={setRowOnHover}
        withCheckboxes={false}
      />
    </WageIndexationHalfGridContainer>
  );
};

export default OriginalWageValuesGrid;
